import { render, staticRenderFns } from "./DontMissDetail.vue?vue&type=template&id=2e9b28cb&scoped=true&"
import script from "./DontMissDetail.vue?vue&type=script&lang=js&"
export * from "./DontMissDetail.vue?vue&type=script&lang=js&"
import style0 from "./DontMissDetail.vue?vue&type=style&index=0&id=2e9b28cb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e9b28cb",
  null
  
)

export default component.exports